import { SettingsStore } from "@ts/common/service/Store/SettingsStore";
export var SettingsStoreInstance = new SettingsStore();
